import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'
import { Button, HelpBlock, InputGroup } from 'react-bootstrap'

import { FormField } from 'internal-components/src/components/Form'
import Icon from 'internal-components/src/components/Icon'

export default function CouponCode({
  applyCoupon,
  coupon = '',
  errors,
  hasCoupon = false,
  setCoupon,
  working = false,
}) {
  const icon = <Icon name="rocket" spin={working} />
  const button = hasCoupon ? (
    <Button
      bsSize="large"
      onClick={() => {
        setCoupon('')
        applyCoupon()
      }}
    >
      {icon} Remove Coupon
    </Button>
  ) : (
    <Button bsSize="large" onClick={() => applyCoupon()}>
      {icon} Apply Coupon
    </Button>
  )

  return (
    <div className="coupon-code">
      <FormField
        bsSize="large"
        controlId="couponCode"
        controlLabel="Coupon Code"
        disabled={hasCoupon}
        errors={errors}
        feedback={false}
        onChange={e => setCoupon(e.target.value)}
        value={coupon}
      >
        {control => (
          <div>
            <InputGroup>
              {control}
              <InputGroup.Button>{button}</InputGroup.Button>
            </InputGroup>

            {hasCoupon && (
              <HelpBlock>
                The coupon code <strong>{coupon}</strong> has been applied.
              </HelpBlock>
            )}
          </div>
        )}
      </FormField>
    </div>
  )
}

CouponCode.propTypes = {
  applyCoupon: Pt.func.isRequired,
  coupon: Pt.string,
  errors: Ipt.map.isRequired,
  hasCoupon: Pt.bool,
  setCoupon: Pt.func.isRequired,
  working: Pt.bool,
}



// WEBPACK FOOTER //
// ./src/components/Signup/CouponCode.jsx